import { render, staticRenderFns } from "./AddPlan.vue?vue&type=template&id=31ac664a&scoped=true&"
import script from "./AddPlan.vue?vue&type=script&lang=js&"
export * from "./AddPlan.vue?vue&type=script&lang=js&"
import style0 from "./AddPlan.vue?vue&type=style&index=0&id=31ac664a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ac664a",
  null
  
)

export default component.exports